var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPagerduty1 = function SvgPagerduty1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 43,
    fill: "none",
    viewBox: "0 0 39 43"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2411_171116)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#06AC38",
    stroke: "#fff",
    strokeWidth: 1.346,
    d: "m21.035 3.05 12.161 7.038a2.81 2.81 0 0 1 1.4 2.433V26.6a2.81 2.81 0 0 1-1.4 2.433l-12.161 7.039a2.79 2.79 0 0 1-2.8 0L6.074 29.032a2.81 2.81 0 0 1-1.4-2.433V12.52a2.81 2.81 0 0 1 1.4-2.433l12.161-7.039a2.79 2.79 0 0 1 2.8 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.448 22.01h-1.843v3.224h1.843zM23.056 14.066c-.916-.498-1.558-.579-3.062-.579h-3.39v7.14h3.377c1.337 0 2.34-.08 3.222-.673.963-.639 1.464-1.709 1.464-2.947 0-1.333-.615-2.403-1.61-2.941m-2.68 5.067h-2.053v-4.118L20.262 15c1.765-.013 2.647.606 2.647 2.026 0 1.528-1.096 2.106-2.534 2.106"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2411_171116",
    width: 38.403,
    height: 42.252,
    x: 0.434,
    y: 0.217,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.783
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.783
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.200691 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2411_171116"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2411_171116",
    result: "shape"
  })))));
};
export default SvgPagerduty1;